module.exports = __webpack_public_path__ + "img/promolider.890ea752.png";